import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
// import styled from '@emotion/styled';
// import { useTheme } from "@mui/material";

// const TextInputWrapperStyled = styled.div`
//  .rw-state-focus .MuiInputBase-input .MuiOutlinedInput-input .MuiInputBase-inputSizeSmall {
//     border-color: ${({ main }) => main};
//     box-shadow: 0px 0px 0px 3px rgba(${({ mainRGB }) => mainRGB}, 0.25);
//   }
// `;

const TextInput = ({ id, name, type, typeName, order, label, required, multiple, options, input, meta }) => {

  // const { palette } = useTheme();
  // const { primary: { contrastText, main, mainRGB } } = palette;

  const [text, setText] = useState("");
  const [attribute, setAttribute] =
    useState({
      ROWS: null,
      MAX_ROWS: null
    });

  // useEffect(() => {
  //   console.log('TEXT useEffect', name);
  // }, []);

  // when component is already mount
  useEffect(() => {

    const newAttribute = { ...attribute };

    let defaultValue = "";
    // Compute default value, choose first from options(in normal case there should be single option/value)
    if (options) {
      for (let option of options) {
        if (option.default) {
          defaultValue = option.value;
        }
        if (option.typeName === 'ROWS') {
          newAttribute.ROWS = option.value;
        }
        if (option.typeName === 'MAX_ROWS') {
          newAttribute.MAX_ROWS = option.value;
        }
      }

      setAttribute(newAttribute);

      // Set default value
      if (defaultValue) {
        // input.onChange(defaultValue);
        setText(defaultValue);
        // console.log('TEXT useEffect options', defaultValue)
        return input.onChange({
          id,
          typeName,
          order,
          result: defaultValue
        });
      }
    }
    input.onChange(null);
    // }, [options]);
  }, []);

  const changeHandler = (event) => {
    event.preventDefault();
    setText(event?.target?.value);

    if (!event?.target?.value) {
      return input.onChange(null);
    }

    return input.onChange({
      id,
      typeName,
      order,
      result: event.target.value
    });
  };

  return (
    // <Box
    //   noValidate
    //   autoComplete="off"
    // >
    // <TextInputWrapperStyled main={main} mainRGB={mainRGB}>
    <TextField
      size="small"
      fullWidth
      value={text}
      multiline={multiple}
      onKeyPress={event => !multiple && event.key === 'Enter' && event.preventDefault()}
      onChange={changeHandler}
      rows={attribute?.['ROWS']}
      maxRows={attribute?.['MAX_ROWS']}
    />
    // </TextInputWrapperStyled>
    // </Box>
  );

  // return (
  //   <div key={id}>
  //     <label>
  //       <input type="text"
  //         name={`${input.name}[${id}]`}
  //         value={text}
  //         onChange={(event) => {
  //           // return input.onChange(event.target.value);
  //           setText(event.target.value);

  //           if (!event.target.value) {
  //             return input.onChange(null);
  //           }

  //           return input.onChange({
  //             id,
  //             typeName,
  //             order,
  //             result: event.target.value
  //           });

  //         }}/>
  //     </label>
  //   </div>
  // );
}

export default TextInput;